"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECT_DESTINATION_STRING = exports.SELECT_REPORT_STRING = void 0;
exports.SELECT_REPORT_STRING = 'Select Report';
exports.SELECT_DESTINATION_STRING = 'Select Destination';
